import { cn } from "../../utils/class-names";
import type { IconProps } from "../types";

export function CoinbaseWalletIcon({ className }: IconProps): JSX.Element {
  return (
    <svg
      className={cn("h-6 w-6", className)}
      fill="none"
      viewBox="0 0 56 56"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28 56c15.464 0 28-12.536 28-28S43.464 0 28 0 0 12.536 0 28s12.536 28 28 28Z"
        fill="#1B53E4"
      />
      <path
        clipRule="evenodd"
        d="M7 28c0 11.598 9.402 21 21 21s21-9.402 21-21S39.598 7 28 7 7 16.402 7 28Zm17.234-6.766a3 3 0 0 0-3 3v7.533a3 3 0 0 0 3 3h7.533a3 3 0 0 0 3-3v-7.533a3 3 0 0 0-3-3h-7.533Z"
        fill="#fff"
        fillRule="evenodd"
      />
    </svg>
  );
}
